import { HOLIDAYS, HOLIDAYS_LOADING } from "../actions/types";

const initialState = {
  isLoading: false,
  data: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case HOLIDAYS:
      return {
        ...state,
        isLoading: false,
        ...action.payload
      };
    case HOLIDAYS_LOADING:
      return {
        ...state,
        isLoading: true
      };
    default:
      return state;
  }
}
